import styled from 'styled-components';
import { Typography } from '@thinknet-gmbh/platform-common-ui';

export const StyledWrapper = styled.div`
  display: flex;
  max-width: 1300px;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;
`;

export const TitleRowLabel = styled(Typography)`
  margin-bottom: 10px;
`;

export const StyledRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  width: 100%;
`;

export const PersonalInfoMainWrapper = styled.div`
  width: 100%;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    margin: 16px 0;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
`;

interface IProps {
  columns?: string;
  columnGap?: number;
}

export const InfoBlock = styled.div<IProps>`
  width: 100%;
  display: grid;
  ${({ columns }: IProps) =>
    columns ? `grid-template-columns: ${columns};` : `grid-template-columns: repeat(4, 1fr);`};
`;


export const InfoBlockContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;
  & > div:first-child {
    margin-right: 8px;
  }
  & > div:last-child {
    word-wrap: break-word;
  }
`;
